import { render, staticRenderFns } from "./dialogOrgStructure.vue?vue&type=template&id=5182fc59&scoped=true&"
import script from "./dialogOrgStructure.vue?vue&type=script&lang=js&"
export * from "./dialogOrgStructure.vue?vue&type=script&lang=js&"
import style0 from "./dialogOrgStructure.vue?vue&type=style&index=0&id=5182fc59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182fc59",
  null
  
)

export default component.exports